import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import moment from 'moment';

import { DatePicker } from 'material-ui-pickers';

import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import InfoIcon from '@material-ui/icons/Info';
import ScheduleIcon from '@material-ui/icons/Repeat';

import avatar from '@material-ui/core/colors/amber';

const styles = theme => ({
  root: {
    marginTop: theme.spacing.unit*3,
  },
  actions: {
    margin: theme.spacing.unit,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  avatar: {
    marginRight: theme.spacing.unit*2,
    color: '#fff',
    backgroundColor: avatar[500],
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
  },
  footer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  schedule: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  scheduleItems: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    alignItems: 'baseline',
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit*2,
  },
  description: {
    flexGrow: 1,
    marginRight: theme.spacing.unit,
  },
  monthlyAmount: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
  },
  title: {
    flexGrow: 1,
  },
  startingDate: {
    marginRight: theme.spacing.unit*2,
  },
  howOften: {
    marginRight: theme.spacing.unit*2,
  },
  numTimes: {
    marginRight: theme.spacing.unit*2,
  },
});

const Maintenance = (props) => {
  const { classes, task, handleChange } = props;

  return(
    <Card className={classes.root}>
      <CardContent className={classes.content}>
        <TextField
          className={classes.title}
          id="title"
          label="Title"
          placeholder="Enter title"
          margin="normal"
          value={task.title}
          onChange={ event => handleChange("title", event.target.value)}
        />
      <div className={classes.row}>
          <TextField
            className={classes.description}
            id="description"
            label="Description"
            multiline
            rows="4"
            placeholder="Describe the task"
            margin="normal"
            value={task.description}
            onChange={ event => handleChange("description", event.target.value)}
          />
          <div className={classes.monthlyAmount}>
            <TextField
              id="monthlyAmount"
              type="number"
              label="Monthly Amount"
              margin="normal"
              value={task.monthlyAmount}
              onChange={ event => handleChange("monthlyAmount", event.target.value)}
              InputProps={{
                startAdornment: <InputAdornment position="start">$</InputAdornment>,
              }}
            />
          </div>
        </div>
        <div className={classes.schedule}>
          <Avatar className={classes.avatar}>
            <ScheduleIcon />
          </Avatar>
          <div className={classes.scheduleItems}>
            <DatePicker
              className={classes.startingDate}
              label="Starting Date"
              format="MMMM Do YYYY"
              value={task.scheduleStart}
              leftArrowIcon={<ArrowBackIcon />}
              rightArrowIcon={<ArrowForwardIcon />}
              onChange={(date) => handleChange("scheduleStart", date.toDate().getTime())}
            />
            <TextField
              className={classes.howOften}
              disabled
              id="scheduleFrequency"
              label="How often it occurs?"
              margin="normal"
              value="Monthly"
              onChange={ event => handleChange("scheduleFrequency", event.target.value)}
            />
            <TextField
              className={classes.numTimes}
              id="scheduleOccurences"
              type="number"
              label="How many times?"
              margin="normal"
              value={task.scheduleOccurences}
              onChange={ event => handleChange("scheduleOccurences", event.target.value)}
            />
            <TextField
              id="scheduleHours"
              type="number"
              label="Hours Budget"
              margin="normal"
              value={task.scheduleHours}
              onChange={ event => handleChange("scheduleHours", event.target.value)}
            />
          </div>
        </div>
        <div className={classes.footer}>
          <InfoIcon />
          <Typography>
            {`An invoice will be created every Month starting ${moment(task.scheduleStart).format("MMMM Do YYYY")}`}
          </Typography>
        </div>
      </CardContent>
    </Card>
  );
};

export default withStyles(styles)(Maintenance);



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/Tasks/Maintenance.jsx